<div class="row">
    <div class="col-12">
        <div class="logo">
        </div>
    </div>
</div>